import React from 'react'

const Wave = () => {
  return (
    <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none h-18 sm:h-20 lg:h-[15vh]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <defs>
          <path
            id="gentle-wave"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18v44h-352z"
          />
        </defs>
        <g className="waves">
          <use
            xlinkHref="#gentle-wave"
            x="50"
            y="0"
            fill="#f5f5f5"
            fillOpacity=".2"
            transformBox="fill-box"
            transformOrigin="center"
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              values="-90 0; 85 0"
              dur="2s"
              begin="-2s"
              repeatCount="indefinite"
            />
          </use>
          <use
            xlinkHref="#gentle-wave"
            x="50"
            y="3"
            fill="#f5f5f5"
            fillOpacity=".5"
            transformBox="fill-box"
            transformOrigin="center"
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              values="-90 0; 85 0"
              dur="6s"
              begin="-3s"
              repeatCount="indefinite"
            />
          </use>
          <use
            xlinkHref="#gentle-wave"
            x="50"
            y="6"
            fill="#f5f5f5"
            fillOpacity=".9"
            transformBox="fill-box"
            transformOrigin="center"
          >
            <animateTransform
              attributeName="transform"
              type="translate"
              values="-90 0; 85 0"
              dur="3s"
              begin="-4s"
              repeatCount="indefinite"
            />
          </use>
        </g>
      </svg>
    </div>
  );
}

export default Wave